// BookingHistoryPage.tsx
import React, { useEffect, useState } from "react";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "./utils/firebase";

// Props type for accepting onClose
interface BookingHistoryPageProps {
  onClose: () => void;
}

const BookingHistoryPage: React.FC<BookingHistoryPageProps> = ({ onClose }) => {
  const [bookings, setBookings] = useState<any[]>([]);
  const user = JSON.parse(localStorage.getItem("user") || "{}");

  useEffect(() => {
    const fetchBookings = async () => {
      try {
        const q = query(
          collection(db, "bookings"),
          where("userId", "==", user.uid)
        );
        const snapshot = await getDocs(q);
        const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setBookings(data);
      } catch (error) {
        console.error("Error fetching bookings: ", error);
      }
    };

    if (user?.uid) {
      fetchBookings();
    }
  }, [user]);

  // Utility to display address as string
  const formatAddress = (addressObj: any) => {
    if (!addressObj) return "-";
    const { street, city, state, pincode, landmark } = addressObj;
    return [street, city, state, pincode, landmark].filter(Boolean).join(", ");
  };

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-2xl font-bold">Booking History</h1>
        {/* Close Button */}
        <button
          onClick={onClose}
          className="bg-red-100 hover:bg-red-200 text-red-600 font-bold py-1 px-4 rounded"
        >
          Close
        </button>
      </div>
      {bookings.length === 0 ? (
        <p>No bookings yet.</p>
      ) : (
        <ul className="space-y-4">
          {bookings.map((booking) => (
            <li key={booking.id} className="border p-4 rounded shadow">
              <p><strong>Service:</strong> {booking.serviceName}</p>
              <p><strong>Price:</strong> ₹{booking.servicePrice}</p>
              <p><strong>Date:</strong> {booking.date} {booking.time && `at ${booking.time}`}</p>
              <p><strong>Address:</strong> {formatAddress(booking.address)}</p>
              <p><strong>Status:</strong> {booking.status || "Pending"}</p>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default BookingHistoryPage;
